import React, { useContext, useEffect, useRef, useState } from "react";
import SuperSignalRContext from "../../Contexts/SignalRContext/SuperUser/SuperSignalRContext";
import {
  getImageSasTokenSilently,
  peekImageSasToken,
  refreshImageSasToken,
} from "../../Services/imageSasToken";

function SubjectImage({
  imageUrl,
  fallbackSrc,
  onError,
  entityId,
  ...imgProps
}) {
  const { imageScopeEntityId } = useContext(SuperSignalRContext);
  const scopedEntityId =
    (entityId === undefined ? imageScopeEntityId : entityId) || null;

  const [token, setToken] = useState(() => peekImageSasToken(scopedEntityId));
  const retriedRef = useRef(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    retriedRef.current = false;
  }, [imageUrl, scopedEntityId]);

  useEffect(() => {
    setToken(peekImageSasToken(scopedEntityId));
  }, [scopedEntityId]);

  useEffect(() => {
    if (!imageUrl || token) return;

    let cancelled = false;
    getImageSasTokenSilently(scopedEntityId)
      .then((next) => {
        if (!cancelled && mountedRef.current) setToken(next);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [imageUrl, token, scopedEntityId]);

  const handleError = (event) => {
    const node = event.currentTarget ?? event.target;

    const forwardError = () => {
      if (event.currentTarget == null) event.currentTarget = node;
      onError?.(event);
    };

    if (!imageUrl || retriedRef.current) {
      forwardError();
      return;
    }

    retriedRef.current = true;
    refreshImageSasToken(scopedEntityId, token).then(
      (next) => {
        if (mountedRef.current) setToken(next);
      },
      () => {
        if (!mountedRef.current) return;
        setToken(null);
        forwardError();
      },
    );
  };

  if (imageUrl && !token) {
    return <img {...imgProps} src={fallbackSrc} alt={imgProps.alt ?? ""} />;
  }

  return (
    <img
      {...imgProps}
      alt={imgProps.alt ?? ""}
      src={imageUrl ? `${imageUrl}${token}` : fallbackSrc}
      onError={handleError}
    />
  );
}

export default SubjectImage;
